import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { DropdownMenuSection } from './dropdown-menu-section';

@Component({
  selector: 'bom-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
})
export class DropdownMenuComponent implements OnInit {
  @Input()
  buttonText: string;

  @Input()
  sections: DropdownMenuSection[];

  @Input()
  isOpen: boolean;

  @Input()
  type: 'normal' | 'inverted' = 'normal';

  constructor(private _elementRef: ElementRef) {}

  ngOnInit() {}

  @HostListener('focusout', ['$event'])
  focusout(event: FocusEvent) {
    const hostElement = this._elementRef.nativeElement as HTMLElement;
    const targetElement = event.relatedTarget as HTMLElement;
    if (!hostElement.contains(targetElement)) {
      this.isOpen = false;
    }
  }

  onClick(event: PointerEvent | KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  doAction(event: PointerEvent, action: () => any) {
    event.stopPropagation();
    action();
  }
}
